import React from "react";

const Login  = () => {
    return (
        <>
        <h1>Login page</h1>
        </>
    )
}

export default Login;